exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-date-number-iteration[data-v-2e792e63] {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #e7f2ff;\n  color: #225cbd;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.input-date-number-iteration span.value[data-v-2e792e63] {\n    display: inline-block;\n    text-align: center;\n    width: 100%;\n}\n", ""]);

// exports
